import Vue from "vue";
import Router from "vue-router";
import External from "../views/external/External";
import Login from "../views/external/Login";
import Registration from "../views/external/Registration";
import RequestPasswordReset from "../views/external/RequestPasswordReset";
import ResetPassword from "../views/external/ResetPassword";
import Main from "../views/main/Main";
import Course from "../views/main/Course";
import Courses from "../views/main/Courses";
import Profile from "../views/main/Profile";
import CourseAdministration from "../views/main/CourseAdministration";
import UserAdministration from "../views/main/UserAdministration";
import CourseRelationships from "../views/main/CourseRelationships";
import SessionReports from "../views/main/SessionReports";
import QuestionBank from "../views/main/QuestionBank";
import ExamAdministration from "../views/main/ExamAdministration";
import RouterUtils from "./RouterUtils";
import SubmitScantron from "../views/main/SubmitScantron";
import ScoreReports from "../views/main/ScoreReports";
import ScoreReport from "../views/main/ScoreReport";
import ScoreTables from "../views/main/ScoreTables";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/external",
      name: "External",
      component: External,
      children: [
        {
          path: "/login",
          name: "Login",
          component: Login
        },
        {
          path: "/requestPasswordReset",
          name: "ResetPasswordReset",
          component: RequestPasswordReset
        },
        {
          path: "/resetPassword/:token",
          name: "ResetPassword",
          component: ResetPassword,
          props: true
        },
        {
          path: "/registration/:token",
          name: "Registration",
          component: Registration,
          props: true
        }
      ]
    },
    {
      path: "/",
      name: "Main",
      component: Main,
      beforeEnter: (to, from, next) => {
        RouterUtils.navGuardLoggedIn(next);
      },
      children: [
        {
          path: "/course/:id?",
          name: "Course",
          component: Course,
          props: true
        },
        {
          path: "/courses",
          name: "Courses",
          component: Courses
        },
        {
          path: "/sessionReports/:id",
          name: "SessionReports",
          component: SessionReports,
          props: true
        },
        {
          path: "/profile/:user?",
          name: "Profile",
          component: Profile,
          props: true
        },
        {
          path: "/courseAdministration",
          name: "CourseAdministration",
          component: CourseAdministration,
          beforeEnter: (to, from, next) => {
            RouterUtils.navGuardAdmin(next);
          }
        },
        {
          path: "/courseRelationships",
          name: "CourseRelationships",
          component: CourseRelationships,
          beforeEnter: (to, from, next) => {
            RouterUtils.navGuardAdmin(next);
          }
        },
        {
          path: "/userAdministration",
          name: "UserAdministration",
          component: UserAdministration,
          beforeEnter: (to, from, next) => {
            RouterUtils.navGuardAdmin(next);
          }
        },
        {
          path: "/questionBank/:id?",
          name: "QuestionBank",
          component: QuestionBank,
          props: true
        },
        {
          path: "/examAdministration",
          name: "ExamAdministration",
          component: ExamAdministration,
          props: true,
          beforeEnter: (to, from, next) => {
            RouterUtils.navGuardAdmin(next);
          }
        },
        {
          path: "/scoreTables",
          name: "ScoreTables",
          component: ScoreTables,
          props: true
        },
        {
          path: "/scoreReports",
          name: "ScoreReports",
          component: ScoreReports
        },
        {
          path: "/scoreReport",
          name: "ScoreReport",
          component: ScoreReport,
          props: true
        },
        {
          path: "/submitScantron",
          name: "SubmitScantron",
          component: SubmitScantron,
          props: true
        }
      ]
    }
  ]
});
